import { changeAppearance } from './changeAppearance'
import { changeTermsOfUse } from './changeTermsOfUse'
import { getAppearance } from './getAppearance'
import { getIdeaFeedParams } from './getIdeaFeedParams'
import { getScores } from './getScores'
import { getTermsOfUse } from './getTermsOfUse'
import { recalculateUserScores } from './recalculateUserScores'
import { resetUserScores } from './resetUserScores'
import { updateIdeaFeedParams } from './updateIdeaFeedParams'
import { updateScores } from './updateScores'

export const configsService = {
  getAppearance,
  changeAppearance,

  getTermsOfUse,
  changeTermsOfUse,

  getScores,
  resetUserScores,
  recalculateUserScores,
  updateScores,

  getIdeaFeedParams,
  updateIdeaFeedParams,
}
